<template>
  <div class="loadingio-spinner-rolling">
    <div class="stage loader-svg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        class="flip-transform"
      >
        <radialGradient
          id="a122"
          cx=".66"
          fx=".66"
          cy=".3125"
          fy=".3125"
          gradientTransform="scale(1.5)"
        >
          <stop offset="0" stop-color="#454CA5"></stop>
          <stop offset=".3" stop-color="#454CA5" stop-opacity=".9"></stop>
          <stop offset=".6" stop-color="#454CA5" stop-opacity=".6"></stop>
          <stop offset=".8" stop-color="#454CA5" stop-opacity=".3"></stop>
          <stop offset="1" stop-color="#454CA5" stop-opacity="0"></stop>
        </radialGradient>
        <circle
          transform-origin="center"
          fill="none"
          stroke="url(#a122)"
          stroke-width="15"
          stroke-linecap="round"
          stroke-dasharray="200 1000"
          stroke-dashoffset="0"
          cx="100"
          cy="100"
          r="70"
        >
          <animateTransform
            type="rotate"
            attributeName="transform"
            calcMode="spline"
            dur="1"
            values="360;0"
            keyTimes="0;1"
            keySplines="0 0 1 1"
            repeatCount="indefinite"
          ></animateTransform>
        </circle>
        <circle
          transform-origin="center"
          fill="none"
          opacity=".2"
          stroke="#454CA5"
          stroke-width="15"
          stroke-linecap="round"
          cx="100"
          cy="100"
          r="70"
        ></circle>
      </svg>
      <div class="loader-text">
        <template v-if="submitApprovalFlag">
          Workflow is underProcess. Please do not refresh the page
        </template>
        <template v-else>
          Do not refresh or close your browser. We are processing your
          request.</template
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "loader",
  props: {
    submitApprovalFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style scoped>
@keyframes ldio {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.ldio div {
  position: absolute;
  width: 65.52px;
  height: 65.52px;
  border: 7.28px solid #a5a5a5;
  border-top-color: transparent;
  border-radius: 50%;
}

.ldio div {
  animation: ldio 1.3513513513513513s linear infinite;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loadingio-spinner-rolling {
  width: 100%;
  height: 100%;
  display: inline-block;
  overflow: hidden;
  background: hsl(0deg 0% 100% / 70%);
  backdrop-filter: blur(5px);
  left: 0 !important;
  /* filter: blur(20px); */
  position: absolute;
  z-index: 999999;
  top: 0;
}
.ldio {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio div {
  box-sizing: content-box;
}

.stage {
  display: grid;
  place-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}

.dot-pulse {
  position: relative;
  left: -9999px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background-color: #fff;
  color: #fff;
  box-shadow: 9999px 0 0 -5px;
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;
}

.dot-pulse::before,
.dot-pulse::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background-color: #fff;
  color: #fff;
}

.dot-pulse::before {
  box-shadow: 9984px 0 0 -5px;
  animation: dot-pulse-before 1.5s infinite linear;
  animation-delay: 0s;
}

.dot-pulse::after {
  box-shadow: 10014px 0 0 -5px;
  animation: dot-pulse-after 1.5s infinite linear;
  animation-delay: 0.5s;
}

.loader-text {
  color: rgba(69, 76, 165, 1) !important;
  margin: 0 auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 52%;
  text-align: center;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 15px;
}

.loader-svg svg {
  width: 70px;
  height: 70px;
  margin-bottom: 60px;
}

@keyframes dot-pulse-before {
  0% {
    box-shadow: 9984px 0 0 -5px;
  }

  30% {
    box-shadow: 9984px 0 0 2px;
  }

  60%,
  100% {
    box-shadow: 9984px 0 0 -5px;
  }
}

@keyframes dot-pulse {
  0% {
    box-shadow: 9999px 0 0 -5px;
  }

  30% {
    box-shadow: 9999px 0 0 2px;
  }

  60%,
  100% {
    box-shadow: 9999px 0 0 -5px;
  }
}

@keyframes dot-pulse-after {
  0% {
    box-shadow: 10014px 0 0 -5px;
  }

  30% {
    box-shadow: 10014px 0 0 2px;
  }

  60%,
  100% {
    box-shadow: 10014px 0 0 -5px;
  }
}

.flip-transform {
  transform: scaleX(-1);
}
</style>
